<template>
  <div
    class="h5-account-container"
    :style="{ '--height': innerHeight }"
  >
    <div class="h5-loging-out">
      <div class="logout-header">
        <img
          @click="hiddenPop"
          v-if="popVisible"
          src="@/assets/H5/order/icon-arrow-left.svg"
          alt=""
        >
        <div
          class="logout-header-title"
          :class="{ center: popVisible }"
        >
          {{ title }}
        </div>
        <img
          src="@/assets/H5/offer/sourcing-close.svg"
          alt=""
          class="logout-header-close"
          @click="closeBtn"
        >
      </div>
      <div class="logout-content">
        <img
          src="@/assets/H5/login/logout-bg.png"
          alt=""
          class="h5-logout-bg"
        >
        <div class="logout-account">
          <img
            src="@/assets/H5/login/account.png"
            alt=""
          >
        </div>
        <div class="logout-welcome-title">
          Welcome back,
        </div>
        <div class="logout-welcome-email">
          {{ userInfo.email || "" }}
        </div>
        <div class="logout-center">
          <div class="logout-menu">
            <div
              @click="goCarts"
              class="logout-menu-item"
            >
              <div class="icon">
                <img
                  v-if="cartStore.cartCount"
                  src="@/assets/H5/order/full-carts.svg"
                  alt=""
                >
                <img
                  v-else
                  src="@/assets/H5/order/carts.svg"
                  alt=""
                >
              </div>
              <div class="text">
                My Carts
                <div
                  v-if="cartStore.cartCount"
                  class="cartCount"
                >
                  {{ cartStore.cartCount > 99 ? '99+' : cartStore.cartCount }}
                </div>
              </div>
            </div>
            <div
              @click="goOrders"
              class="logout-menu-item"
            >
              <div class="icon">
                <Icon
                  name="order-l"
                  alt=""
                />
              </div>
              <div class="text">
                Fulfillment Orders
              </div>
            </div>
            <div
              @click="showShipAddress"
              class="logout-menu-item"
            >
              <div class="icon">
                <img
                  src="@/assets/H5/order/address.svg"
                  alt=""
                >
              </div>
              <div class="text">
                Shipping Address
              </div>
            </div>
            <div
              @click="handleGoDropshipping"
              class="logout-menu-item"
            >
              <div class="icon">
                <img
                  src="@/assets/images/bound_store.svg"
                  alt=""
                  width="24px"
                >
              </div>
              <div class="text flex-center">
                {{ hasBoundStore ? 'Go Dropshipping' : 'Link Store' }}
                <span
                  v-if="!hasBoundStore"
                  class="suffix"
                >NEW</span>
              </div>
            </div>
          </div>
        </div>
        <div class="h5-logout-bottom">
          <div class="_item">
            <img
              src="@/assets/H5/login/help-center.svg"
              alt=""
            >
            <span @click="goHelpCenter">Help Center</span>
          </div>
          <div class="_item">
            <img
              src="@/assets/H5/login/logout.svg"
              alt=""
            >
            <span @click="singOut">Sign Out</span>
          </div>
        </div>
      </div>

      <div
        class="pop-container"
        :class="{ visible: popVisible }"
        @click.stop
      >
        <H5AddressInfo
          v-if="showAddressInfo"
          :handle-close="handleCloseAddressDialog"
          :address-type="3"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import H5AddressInfo from '@/components/H5/H5AddressInfo/index.vue'
import { buriedPointUtil } from '@/utils/utils'
import { usePlugin } from '@/hooks/usePlugin'
import { useUserStore } from '@/pinia/user'
import { useLogin } from '@/components/Login'
import { useCartStore } from '@/pinia/cart'
import { useDropshipping } from '@/components/Dropshipping/useDropshipping'
import { Icon } from '@/components/Icon'

const { hasBoundStore, onDropshipping } = useDropshipping()

const ORIGIN_TITLE = 'My Account'

const title = ref(ORIGIN_TITLE)

const router = useRouter()

const cartStore = useCartStore()

const user = useUserStore()
const { logout } = useLogin()
const { $toast } = usePlugin()

const userInfo = computed(() => user.userInfo)

const popVisible = ref(false)

const showAddressInfo = ref(false)

const innerHeight = ref(0)

onMounted(() => {
  innerHeight.value = window.innerHeight
})

const closeBtn = (event) => {
  if (popVisible.value) {
    hiddenPop()
  } else {
    router.back()
  }
}

const goCarts = () => {
  buriedPointUtil({ eventId: 'MPPC201' })
  router.push('/carts')
}

const goOrders = () => {
  router.push('/orders')
}

const goHelpCenter = () => {
  router.push('/help')
}

const singOut = async () => {
  await logout()
}

const showShipAddress = () => {
  showAddressInfo.value = true
  title.value = 'Shipping Address'
  showPop()
}

const showPop = () => {
  popVisible.value = true
}

const hiddenPop = () => {
  popVisible.value = false
  title.value = ORIGIN_TITLE
  showAddressInfo.value = false
}

const handleCloseAddressDialog = () => {
  hiddenPop()
  $toast('Saved successfully')
}

const handleGoDropshipping = () => {
  if (hasBoundStore.value) {
    $toast('Please use your PC to use this function.', { type: 'error' })
  } else {
    onDropshipping()
  }
}
</script>

<style lang="less" scoped>
.h5-account-container {
  padding: 12px;
  background: #131313;
  backdrop-filter: blur(8px);
  height: calc(var(--height) * 1px);
}

.h5-loging-out {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  .logout-header {
    position: relative;
    padding: 0 12px;
    background-color: #FFFFFF;
    width: 100%;
    height: 48px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logout-header-title {
      font-family: mon-600;
      color: #232323;
      font-size: 14px;
      line-height: 18px;

      &.center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .logout-content {
    flex: 1;
    margin-top: 12px;
    border-radius: 8px;
    background-color: #FFFFFF;
    position: relative;
    .h5-logout-bg {
      position: absolute;
      width: 100%;
      border-radius: 8px;
    }
    .logout-account {
      display: flex;
      justify-content: center;
      position: relative;
      z-index: 1;
      img {
        width: 96px;
        margin-top: 32px;
      }
    }
  }
  .logout-welcome-title {
    text-align: center;
    color: #232323;
    font-family: mon-500;
    font-size: 12px;
    margin-top: 16px;
    line-height: 16px;
  }
  .logout-welcome-email {
    margin-top: 8px;
    color: #232323;
    font-family: mon-600;
    line-height: 20px;
    font-size: 16px;
    text-align: center;
    padding-bottom: 32px;
  }
  .logout-center {
    padding: 6px 0px;
    background-color: #F5F5F5;

    .logout-menu {
      padding: 4px 0;
      background-color: white;

      .logout-menu-item {
        display: flex;
        height: 56px;
        padding-right: 16px;
        &:last-child {
          .text {
            border-bottom: none;
          }
        }
        .icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 56px;
          height: 56px;
          font-size: 24px;
        }
        .text {
          position: relative;
          flex: 1;
          height: 100%;
          line-height: 56px;
          color: #232323;
          font-size: 14px;
          font-family: mon-500;
          border-bottom: 0.5px solid #e4e6eb;

          &.flex-center {
            display: flex;
            align-items: center;
          }

          .cartCount {
            position: absolute;
            top: 50%;
            left: 68px;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background-color: #009DE0;
            color: white;
            font-size: 10px;
            font-family: mon-600;
          }
          .suffix {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 4px;
            width: 30px;
            height: 16px;
            background-color: #1b3e9c;
            color: white;
            border-radius: 2px;
            font-size: 10px;
            font-family: mon-600;
          }
        }
      }
    }
  }
  .h5-logout-bottom {
    margin-top: 20px;
    ._item {
      padding: 0px 16px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span {
        font-family: mon-500;
        font-size: 14px;
        color: #5C5C5C;
        margin-left: 16px;
      }
    }
  }
}

.pop-container {
  position: fixed;
  left: 12px;
  bottom: 12px;
  height: 0;
  width: calc(100% - 24px);
  background-color: white;
  transition: height 0.3s ease-out;
  border-radius: 8px;
  overflow: hidden;
  z-index: 999;

  &.visible {
    height: calc(100% - 48px - 36px );
  }
}
</style>
